import { createContext } from "react";

/**
 * WebtopWindowContext — lets a window's content participate in the window chrome.
 *
 * A few apps (e.g. the embedded Browser) merge their own top bar with the window
 * title bar (Chrome-style: tabs + window controls on one row). For that the app's
 * top strip needs to act as the window's drag handle. Window.jsx provides this so
 * the content can call `startDrag(mouseEvent)` / `toggleMaximize()`.
 *
 * Default is a no-op: outside a webtop window (e.g. the legacy app) `inWebtopWindow`
 * is false and the handlers do nothing, so shared components stay unaffected.
 */
const WebtopWindowContext = createContext({
  inWebtopWindow: false,
  // Id of the window this content renders in (null outside a webtop window). Screens
  // use it to keep per-window state, e.g. independent Leads lists.
  windowId: null,
  startDrag: () => {},
  toggleMaximize: () => {},
});

export default WebtopWindowContext;
